import {
  EfsMelcoEfsModelsSchemaListItem,
  SelectField,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useDataSourceSelect } from "../../hooks/inputFormats/useDataSourceSelect";
import { CustomTokenField } from "./CustomTokenField";

type SelectDataSourceProps = {
  name: string;
  attribute?: string;
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
};

export const SelectDataSource: React.FC<SelectDataSourceProps> = ({
  name,
  attribute,
  dataAssignments,
}) => {
  const { t } = useTranslation();

  const dataSourceSelect = useDataSourceSelect(dataAssignments);

  const fieldName = attribute ? [attribute, name].join(".") : name;

  return (
    <>
      <SelectField
        name={fieldName}
        label={t("dataMappings.form.label.dataSource")}
        style={{ width: "100%" }}
        options={dataSourceSelect}
        showSearch
        optionFilterProp="label"
        filterOption
        allowClear
        placeholder={t("global.fallback.none")}
      />

      <CustomTokenField
        dataAssignments={dataAssignments}
        attribute={attribute}
      />
    </>
  );
};
